export default __webpack_public_path__ + "static/media/charm-s7.94ddf887.png";